import styled from "styled-components";

export const HeadingStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.8rem;
  font-family: semibold-pro, sans-serif;
  margin-bottom: 2rem;

  @media screen and (max-width: 576px) {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
`;

/**
 * Use this for rows that have two columns of label + input
 * e.g. Schedule Date + Recurrence
 */
export const HeadingStyles2 = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;

  /* your label */
  .heading_text {
    flex: 0 0 200px;    /* fixed width for label */
    margin: 0;          /* remove default p-margin */
    font-weight: 500;
  }

  /* your input container */
  .input-div {
    flex: 1;            /* fill remaining space */
    min-width: 150px;   /* never get too small */
  }

  @media screen and (max-width: 768px) {
    /* stack on small screens */
    flex-direction: column;

    .heading_text,
    .input-div {
      width: 100%;
      margin: 0.5rem 0;
    }
  }
`;

export const ThreeFieldRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;

  .field {
    flex: 1;
    min-width: 150px;
    margin-right: 1rem;

    /* label spacing */
    .heading_text {
      margin-bottom: 0.5rem;
      display:flex;
    }
  }

  /* drop right-margin on last column */
  .field:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;

    .field {
      width: 100%;
      margin: 0 0 1rem;
    }
  }
`;
